import React, { useEffect, useRef, useState } from "react";
import { Modal } from "react-bootstrap";
import MessagingList from "./MessagingList";
import LexicalEditor from "./Comman/LexicalEditor";
import { useDispatch, useSelector } from "react-redux";
import {
  getCurrentUser,
  getUserProfilePic,
  getUserProfilePicTwo,
  loadUserProfilePicTwo,
} from "../app/store/auth";
import {
  addAppMessage,
  getAddedNewMessageStatus,
  getAppMsgList,
  getAppMsgReadStatus,
  loadAppMsgList,
  updateMessageRead,
  updateMsgListRead,
} from "../app/store/messages";
import {
  getComponentUserStatus,
  UpdateComponentsUserStatus,
} from "../app/store/tools";

const MESSAGING_POPUP_STYLES = {
  modalContent: {
    borderRadius: "26px",
    overflow: "hidden",
    border: "1px solid rgba(226, 232, 240, 1)",
    boxShadow: "0 24px 60px rgba(15, 23, 42, 0.16)",
  },
  modalDialog: {
    maxWidth: "920px",
  },
  modalHeader: {
    padding: "18px 22px",
    borderBottom: "1px solid rgba(226, 232, 240, 0.9)",
    background: "linear-gradient(135deg, rgba(248, 250, 252, 0.98) 0%, rgba(239, 246, 255, 0.95) 100%)",
  },
  headerContent: {
    width: "100%",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    gap: "14px",
  },
  titleWrap: {
    display: "flex",
    alignItems: "center",
    gap: "14px",
  },
  headerIcon: {
    width: "46px",
    height: "46px",
    borderRadius: "15px",
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    background: "linear-gradient(135deg, rgba(37, 99, 235, 0.12) 0%, rgba(79, 70, 229, 0.16) 100%)",
    color: "#4338ca",
    fontSize: "21px",
    boxShadow: "inset 0 1px 0 rgba(255,255,255,0.6)",
  },
  title: {
    fontSize: "22px",
    fontWeight: 800,
    color: "#0f172a",
    lineHeight: 1.1,
    margin: 0,
  },
  subtitle: {
    fontSize: "12px",
    color: "#64748b",
    marginTop: "4px",
  },
  closeButton: {
    width: "38px",
    height: "38px",
    borderRadius: "999px",
    border: "1px solid rgba(226, 232, 240, 1)",
    background: "#ffffff",
    color: "#64748b",
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    fontSize: "16px",
    fontWeight: 800,
    boxShadow: "0 8px 18px rgba(15, 23, 42, 0.06)",
    flexShrink: 0,
  },
  modalBody: {
    padding: "20px 22px 22px 22px",
    background: "linear-gradient(180deg, #ffffff 0%, #f8fbff 100%)",
  },
  historyCard: {
    borderRadius: "20px",
    border: "1px solid rgba(226, 232, 240, 1)",
    background: "#ffffff",
    boxShadow: "0 12px 26px rgba(15, 23, 42, 0.05)",
    padding: "12px",
    marginBottom: "20px",
    maxHeight: "380px",
    overflowY: "auto",
    display: "flex",
    flexDirection: "column-reverse",
  },
  editorCard: {
    borderRadius: "20px",
    border: "1px solid rgba(226, 232, 240, 1)",
    background: "#ffffff",
    boxShadow: "0 12px 26px rgba(15, 23, 42, 0.05)",
    padding: "18px",
  },
  sectionTitle: {
    fontSize: "15px",
    fontWeight: 800,
    color: "#0f172a",
    marginBottom: "12px",
    display: "flex",
    alignItems: "center",
    gap: "8px",
  },
  fileList: {
    display: "grid",
    gap: "10px",
    marginBottom: "16px",
  },
  fileRow: {
    borderRadius: "14px",
    border: "1px solid rgba(226, 232, 240, 1)",
    background: "#f8fbff",
    padding: "10px 12px",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    gap: "12px",
  },
  fileMeta: {
    minWidth: 0,
    flex: 1,
  },
  fileName: {
    fontSize: "13px",
    fontWeight: 700,
    color: "#0f172a",
    wordBreak: "break-word",
  },
  fileSubtext: {
    fontSize: "11px",
    color: "#64748b",
    marginTop: "2px",
  },
  removeButton: {
    width: "30px",
    height: "30px",
    borderRadius: "999px",
    border: "1px solid rgba(226, 232, 240, 1)",
    background: "#ffffff",
    color: "#ef4444",
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    fontSize: "12px",
    flexShrink: 0,
  },
  footerActions: {
    display: "flex",
    justifyContent: "flex-end",
    gap: "10px",
    marginTop: "20px",
  },
  attachButton: {
    display: "inline-flex",
    alignItems: "center",
    gap: "8px",
    borderRadius: "999px",
    border: "1px solid rgba(226, 232, 240, 1)",
    background: "#ffffff",
    color: "#475569",
    padding: "10px 16px",
    fontSize: "12px",
    fontWeight: 800,
  },
  sendButton: {
    display: "inline-flex",
    alignItems: "center",
    gap: "8px",
    borderRadius: "999px",
    border: "none",
    background: "linear-gradient(135deg, #2563eb 0%, #4f46e5 100%)",
    color: "#ffffff",
    padding: "10px 20px",
    fontSize: "12px",
    fontWeight: 800,
    boxShadow: "0 14px 28px rgba(79, 70, 229, 0.2)",
  },
};

const formatFileSize = (sizeInBytes) => {
  if (!sizeInBytes && sizeInBytes !== 0) return "";
  if (sizeInBytes < 1024) return `${sizeInBytes} B`;
  if (sizeInBytes < 1024 * 1024) return `${(sizeInBytes / 1024).toFixed(1)} KB`;
  return `${(sizeInBytes / (1024 * 1024)).toFixed(1)} MB`;
};

const MessagingPopup = (props) => {
  const {
    msgShowHide,
    handleMsgModalShowHide,
    message,
    handleSendMessage,
    handleSupportMessage,
  } = props;

  const [messageList, setMessageList] = useState([]);
  const [documents, setDocuments] = useState([]);
  const [attachmentShowHide, setAttachmentShowHide] = useState(false);
  const [content, setContent] = useState("");
  const [editorResetKey, setEditorResetKey] = useState(0);
  const [profilePicData, setProfilePicData] = useState(null);
  const [profilePicTwoData, setProfilePicTwoData] = useState(null);

  const appMsgListSelector = useSelector(getAppMsgList);
  const addedNewMessageStatusSelector = useSelector(getAddedNewMessageStatus);
  const componentUserStatusSelector = useSelector(getComponentUserStatus);
  const appMsgReadStatusSelector = useSelector(getAppMsgReadStatus);
  const userProfilePicSelector = useSelector(getUserProfilePic);
  const userProfilePicSelectorTwo = useSelector(getUserProfilePicTwo);

  const dispatch = useDispatch();
  const currentUser = getCurrentUser();
  const fileInputRef = useRef(null);

  useEffect(() => {
    if (message?.id > 0) {
      dispatch(loadAppMsgList(message.id));
    }
    setDocuments([]);
    setContent("");
    setEditorResetKey((key) => key + 1);
    setMessageList([]);
  }, [message]);

  useEffect(() => {
    let usrId = currentUser.id;
    if (currentUser.linkUser)
      usrId = currentUser.linkUser;
    if (appMsgListSelector.length > 0) {
      const msgList = appMsgListSelector.map((item) => {
        let author = "receive";
        let performer = item.fromName + " " + item.fromLastName;
        if (item.fromId === parseInt(usrId)) {
          author = "send";
          performer = item.fromName + " " + item.fromLastName;
        }

        if (item.fromId !== parseInt(usrId)) {
          dispatch(loadUserProfilePicTwo(item.fromId));
        }

        return {
          author: author,
          data: item.message,
          performer: performer,
          date: item.messageDate,
          documents: item.documents,
          id: item.id,
          readStatus: item.readStatus,
        };
      });

      // Reverse the list for column-reverse layout (newest at bottom)
      setMessageList(msgList.reverse());

      if (
        msgList.filter((x) => x.readStatus !== true).length > 0 &&
        message?.id
      )
        dispatch(updateMessageRead(message.id, usrId));
    }
  }, [appMsgListSelector]);

  useEffect(() => {
    if (userProfilePicSelector) {
      let objectURL = "data:image/jpeg;base64," + userProfilePicSelector;
      setProfilePicData(objectURL);
    }
  }, [userProfilePicSelector]);

  useEffect(() => {
    if (userProfilePicSelectorTwo) {
      let objectURL = "data:image/jpeg;base64," + userProfilePicSelectorTwo;
      setProfilePicTwoData(objectURL);
    }
  }, [userProfilePicSelectorTwo]);

  useEffect(() => {
    if (appMsgReadStatusSelector) {
      let msgItems = "";
      messageList.map((x, key) => {
        if (key > 0) msgItems += ",";
        msgItems += x.id;
      });
      if (msgItems !== "") {
        handleUpdateComponent(msgItems);
        updateMsgListRead(false);
        if (handleSendMessage) handleSendMessage();
      }
    }
  }, [appMsgReadStatusSelector]);

  const handleUpdateComponent = (compItems) => {
    const comp = componentUserStatusSelector.filter((x) => x.compId === 9);
    let updCompItems = "";
    if (comp.length > 0) {
      updCompItems = comp[0].compItems;
    }
    const compObj = {
      compName: "Messages",
      performerId: currentUser.id,
      compItems: compItems,
      ciid: message.ciid,
      wiid: message.wiid,
      iiid: message.iiid,
      compId: 9,
    };
    if (compItems !== "" && compItems !== updCompItems) {
      dispatch(UpdateComponentsUserStatus(compObj));
    }
  };

  const handleChange = (newContent) => {
    setContent(newContent);
  };

  const onFileChange = async (event) => {
    const docs = [...documents];
    for (const file of event.target.files) {
      var doc = {
        name: file.name,
        type: file.type,
        size: file.size,
        file: file,
      };
      docs.push(doc);
    }
    setDocuments(docs);
  };

  const handleClick = (event) => {
    console.log(event);
  };

  const onSubmit = () => {
    let usrId = currentUser.id;
    if (currentUser.linkUser)
      usrId = currentUser.linkUser;
    const data = new FormData();
    data.append("message", content);
    data.append("performerId", usrId);
    data.append("communication", JSON.stringify(message));
    data.append("files", JSON.stringify(documents.map(x => ({ name: x.name, type: x.type, size: x.size }))));
    dispatch(addAppMessage(data));
  };

  useEffect(() => {
    if (addedNewMessageStatusSelector?.state) {
      if (message?.id > 0) {
        dispatch(loadAppMsgList(message.id));

        if (handleSupportMessage)
          handleSupportMessage(content, addedNewMessageStatusSelector?.obj);

        setDocuments([]);
        setContent("");
        setEditorResetKey((key) => key + 1);
        //setMessageList([]);
        setAttachmentShowHide(false);
      }
    }
  }, [addedNewMessageStatusSelector]);

  const handleFileRemove = (item) => {
    const updatedDocuments = documents.filter((doc) => doc !== item);
    setDocuments(updatedDocuments);
  };

  const handleAttachmentShowHide = () => {
    setAttachmentShowHide(!attachmentShowHide);
  };

  return (
    <Modal
      show={msgShowHide}
      size="xl"
      centered
      onHide={() => handleMsgModalShowHide("")}
      dialogClassName="messaging-popup-modal-dialog"
      contentClassName="messaging-popup-modal-content"
    >
      <style>
        {`
          .messaging-popup-modal-dialog {
            max-width: ${MESSAGING_POPUP_STYLES.modalDialog.maxWidth};
          }
          .messaging-popup-modal-content {
            border-radius: ${MESSAGING_POPUP_STYLES.modalContent.borderRadius};
            overflow: ${MESSAGING_POPUP_STYLES.modalContent.overflow};
            border: ${MESSAGING_POPUP_STYLES.modalContent.border};
            box-shadow: ${MESSAGING_POPUP_STYLES.modalContent.boxShadow};
          }
          /* Custom scrollbar for history card */
          .history-scroll::-webkit-scrollbar {
            width: 6px;
          }
          .history-scroll::-webkit-scrollbar-track {
            background: #f1f5f9;
            border-radius: 10px;
          }
          .history-scroll::-webkit-scrollbar-thumb {
            background: #cbd5e1;
            border-radius: 10px;
          }
          .history-scroll::-webkit-scrollbar-thumb:hover {
            background: #94a3b8;
          }
          `}
      </style>

      <Modal.Header style={MESSAGING_POPUP_STYLES.modalHeader}>
        <div style={MESSAGING_POPUP_STYLES.headerContent}>
          <Modal.Title as="div" style={MESSAGING_POPUP_STYLES.titleWrap}>
            <div style={MESSAGING_POPUP_STYLES.headerIcon}>
              <i className="fa fa-comments" aria-hidden="true"></i>
            </div>
            <div>
              <div style={MESSAGING_POPUP_STYLES.title}>Messages</div>
              <div style={MESSAGING_POPUP_STYLES.subtitle}>
                Conversation history and secure messaging.
              </div>
            </div>
          </Modal.Title>
          <button
            type="button"
            style={MESSAGING_POPUP_STYLES.closeButton}
            onClick={() => handleMsgModalShowHide("")}
            aria-label="Close messages popup"
          >
            <i className="fa fa-times" aria-hidden="true"></i>
          </button>
        </div>
      </Modal.Header>

      <Modal.Body style={MESSAGING_POPUP_STYLES.modalBody}>
        <div className="history-scroll" style={MESSAGING_POPUP_STYLES.historyCard}>
          {messageList.map((item) => (
            <MessagingList
              key={item.id}
              message={item}
              handleClick={handleClick}
              profilePicData={profilePicData}
              profilePicTwoData={profilePicTwoData}
            ></MessagingList>
          ))}
        </div>

        <div style={MESSAGING_POPUP_STYLES.editorCard}>
          <div style={MESSAGING_POPUP_STYLES.sectionTitle}>
            <i className="fa fa-pencil" aria-hidden="true"></i>
            New Message
          </div>

          {documents.length > 0 && (
            <div style={MESSAGING_POPUP_STYLES.fileList}>
              {documents.map((file, index) => (
                <div key={`${file.name}-${index}`} style={MESSAGING_POPUP_STYLES.fileRow}>
                  <div style={MESSAGING_POPUP_STYLES.fileMeta}>
                    <div style={MESSAGING_POPUP_STYLES.fileName}>{file.name}</div>
                    <div style={MESSAGING_POPUP_STYLES.fileSubtext}>
                      {formatFileSize(file.size)}
                      {file.type ? ` | ${file.type}` : ""}
                    </div>
                  </div>
                  <button
                    type="button"
                    style={MESSAGING_POPUP_STYLES.removeButton}
                    onClick={() => handleFileRemove(file)}
                    aria-label={`Remove ${file.name}`}
                  >
                    <i className="fa fa-times" aria-hidden="true"></i>
                  </button>
                </div>
              ))}
            </div>
          )}

          <LexicalEditor
            key={editorResetKey}
            value={content}
            onChange={handleChange}
          />

          <div style={MESSAGING_POPUP_STYLES.footerActions}>
            <button
              type="button"
              style={MESSAGING_POPUP_STYLES.attachButton}
              onClick={() => fileInputRef.current.click()}
            >
              <i className="fa fa-paperclip mr-2" aria-hidden="true"></i>
              Attach Files
            </button>

            <button
              type="button"
              style={MESSAGING_POPUP_STYLES.sendButton}
              onClick={onSubmit}
            >
              <i className="fa fa-paper-plane-o mr-2" aria-hidden="true"></i>
              Send Message
            </button>
          </div>

          <input
            type="file"
            ref={fileInputRef}
            onChange={onFileChange}
            multiple
            style={{ display: "none" }}
          />
        </div>
      </Modal.Body>
    </Modal>
  );
};


export default MessagingPopup;
